<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab" [class.disabled]="tab.disabled">
      <a (click)="!tab.disabled && changeTab(tab.id)" 
         style="cursor: pointer;" 
         class="btn-sm" 
         [class.disabled]="tab.disabled"
         [style.pointer-events]="tab.disabled ? 'none' : 'auto'"
         [style.opacity]="tab.disabled ? '0.5' : '1'">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        <!-- SMALL loader for form content only -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          <!-- Entity Information Table -->
          <table class="table table-bordered form-inline enityDetails custom-table" style="margin-bottom: 25px;">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span><strong>{{ item.key }}</strong></span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>

          <!-- Form Data Table -->
          <table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="10">{{modalTitle}}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of scheduleFFormView.rows; track itemTracker(i, row); let i = $index) {
<tr>
                <td style="width: 58px">{{row.num}}</td>
                @if (row.num != 1) {
<td>{{row.description}}</td>
}
                @if (row.num == 1) {
<td style="font-weight: normal;">
                  {{getDescriptionBeforeParenthesis(row.description)}} 
                  (<a style="cursor: pointer; color: #337ab7; text-decoration: underline;" 
                      (click)="fetchSchFwhitepaper(row.num)">attach reconciliation to annual statement</a>)
                </td>
}
                @if (row.num != 2 && row.num != 4 && row.num != 13) {
<td style="width: 110px" align="right">
                  <div>
                    <input class="form-control input-md numText"
                           type="number" 
                           [(ngModel)]="row.value"
                           [disabled]="row.is_editable"
                           (ngModelChange)="onValueChange(row, 'value')"
                           aria-describedby="basic-addon2">
                  </div>
                </td>
}
                @if (row.num == 13) {
<td style="width: 110px" align="right">
                  <div>
                    <input class="form-control input-md numText"
                           type="number" 
                           [(ngModel)]="row.value"
                           [disabled]="row.is_editable"
                           (ngModelChange)="onValueChange(row, 'value')"
                           aria-describedby="basic-addon2">
                  </div>
                  <div style="margin-top: 4px;">
                    <div style="text-align: center;">Adjust Round-Off</div>
                    <input class="form-control input-md numText"
                           type="number" 
                           [(ngModel)]="row.value2"
                           [disabled]="row.is_editable2"
                           (ngModelChange)="onValueChange(row, 'value2')"
                           aria-describedby="basic-addon2">
                  </div>
                </td>
}
              </tr>
}
            </tbody>
          </table>

          <!-- Unallocated Amount / Diagnostic -->
          @if (unallocatedAmount && unallocatedAmount.length > 0) {
<table class="table table-bordered form-inline custom-table">
            <tbody>
              @for (row of unallocatedAmount; track $index) {
<tr>
                @for (col of row; track $index; let idx = $index) {
<td width="25%">
                  <span class="bg-grey">
                    @if (idx < 3) {
<span>( {{col.name}} )</span>
}
                    @if (idx == 3) {
<span>(Exception?) : 
                      <input type="checkbox" 
                             [checked]="col.exception_flag === 'Y'"
                             (change)="onExceptionCheckboxChange($event, col)"
                             [disabled]="row[idx-1].value == 0">
                      <span class="diag_check">By Pass Diag.</span>
                    </span>
}
                  </span>
                  <br>
                  @if (idx < 3) {
<span [ngClass]="{'color-red': col.value < 0}">
                    <span>{{col.value | number}}</span>
                  </span>
}
                  @if (idx == 3) {
<span>
                    <span>Exception Reason : </span>
                    <span>
                      <input type="text" 
                             class="form-control exception_input" 
                             [ngClass]="{'input_disabled': col.exception_flag==='N'}" 
                             name="exceptionMsg" 
                             [(ngModel)]="col.exception_msg" 
                             [disabled]="col.exception_flag==='N'">
                    </span>
                  </span>
}
                </td>
}
              </tr>
}
            </tbody>
          </table>
}
        </div>
}
      </div>
    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div class="PC_SCHD_F">
        <table class="custom-table">
          <thead>
            <tr>
              <th colspan="4">
                <span class="schd-name">Schedule F</span>
                <span class="schd-desc">Losses Incurred—Section 832</span>
                <span class="schd-ins">(see instructions)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleFFormView.rows; track itemTracker($index, row)) {
<tr>
              <td class="lineNo">{{row.num}}</td>
              <td class="lineDesc">{{row.description}}</td>
              <td class="valueBlock">
                @if (row.num == '2a' || row.num == '2b' || row.num == '4a' || row.num == '4b' || row.num == 9 || row.num == 10 || row.num == 11) {
<div [ngClass]="{'color-red': row.value < 0}" 
                     class="input_enabled" 
                    >
                  {{row.value | number}}
                </div>
}
              </td>
              <td class="valueBlock">
                @if (row.num == 1 || row.num == '2c' || row.num == 3 || row.num == '4c' || row.num == 5 || row.num == 6 || row.num == 7 || row.num == 8 || row.num == 12 || row.num == 13 || row.num == 14) {
<div [ngClass]="{'color-red': row.value < 0}" 
                     class="input_enabled" 
                    >
                  {{row.value | number}}
                </div>
}
                @if (row.num == 2 || row.num == '2a' || row.num == '2b' || row.num == 4 || row.num == '4a' || row.num == '4b' || row.num == 9 || row.num == 10 || row.num == 11) {
<input class="input_disabled" 
                       
                       disabled="true">
}
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 3) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showRequestLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showRequestLoader) {
<div>
          <div class="main-header">
            <div class="col-sm-4" style="text-align: center;">
              <span>Transaction Number</span>
            </div>
            <div class="col-sm-3">
              <span> User </span>
            </div>
            <div class="col-sm-2">
              <span> Date </span>
            </div>
            <div class="col-sm-3" style="padding-left: 20px">
              <span> View Transactions </span>
            </div>
          </div>

          @if (batchLoader) {
<div class="viewBatchLoader">
            <i class="fa fa-spinner fa-spin gt-refresh"></i>
          </div>
}

          @for (batchItem of BatchList; track $index; let idx = $index) {
<div class="row audit-row">
            <div class="col-sm-4" style="text-align: center;">
              <span>{{batchItem.TRANSACTION_ID}}</span>
            </div>
            <div class="col-sm-3">
              <span>{{batchItem.USER_FIRST_NAME}} {{batchItem.USER_LAST_NAME}}</span>
            </div>
            <div class="col-sm-2">
              <span>{{batchItem.CREATED_ON}}</span>
            </div>
            <div class="col-sm-3">
              <button type="button" 
                      class="btn btn-primary view-trans-btn" 
                      (click)="showUploads(idx, batchItem.TRANSACTION_ID)" 
                      [disabled]="batchItem.show_transaction">
                View Transactions
              </button>
              <span>@if (batchItem.show_transaction) {
<i class="fa fa-spinner fa-spin gt-refresh"></i>
}</span>
            </div>
            
            @if (batchItem.TOGGLE) {
<div style="background: lightgray;width: 69%;margin-top: 28px;margin-left: 15%;">
              @if (batchLoader) {
<div class="viewBatchLoader">
                <i class="fa fa-spinner fa-spin gt-refresh"></i>
              </div>
}
              @if (showBatchData) {
<table class="table table-bordered form-inline custom-table">
                <thead>
                  <tr style="background: #cd5763;color: white;font-weight: bold;">
                    <td style="width: 58px;padding: 0 20px;">#</td>
                    <td style="padding: 0 20px;">Description</td>
                    <td style="width: 110px;padding: 0;text-align: center;">Column A</td>
                  </tr>
                </thead>
                <tbody>
                  @for (batchData of BatchListData; track $index) {
<tr>
                    <td style="width: 58px;padding: 0 20px;">{{batchData.LINE_NO}}</td>
                    <td style="padding: 0 20px;">{{batchData.LINE_DESCRIPTION}}</td>
                    <td style="width: 110px;padding: 0;" align="right">
                      <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                        {{batchData.ATTRIBUTE_VALUE | number}}
                      </div>
                    </td>
                  </tr>
}
                </tbody>
              </table>
}
            </div>
}
          </div>
}
        </div>
}
      </div>
    </div>
}

    <!-- Whitepaper Info Tab -->
    @if (activeTab === 4) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader && formWhitepaper.length > 0) {
<div class="PC_SCHD_A_Diag">
        <div class="diag-blocks">
          <div class="slim-scroll-block">
            <table class="custom-table">
              <thead>
                <tr>
                  <th colspan="3">
                    <span class="schd-name">Forms</span>
                  </th>
                  <th colspan="3">
                    <span class="schd-sub">Total : ${{formsAmt | number}}</span>
                  </th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: center;width: 42px;">
                    <span>#</span>
                  </th>
                  <th colspan="3">
                    <span>Forms Description</span>
                  </th>
                  <th colspan="2" style="text-align: right;" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (row of formWhitepaper; track $index) {
<tr>
                  <td colspan="1">{{row.LINE_NO}}</td>
                  <td colspan="3"> &nbsp; {{row.DESCRIPTION}}</td>
                  <td colspan="2" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT | number}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      @if (!showFormLoader && formWhitepaper.length == 0) {
<div class="PC_SCHD_A_Diag">
        <div style="height:auto;">
          <table class="custom-table">
            <tbody>
              <tr>
                <td colspan="12">Whitepaper info unavailable.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
}
    </div>
}
  </div>
</div>

<!-- STANDARD Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button" 
          (click)="save()" 
          [disabled]="isSaveClicked || crudLoading">
    @if (!crudLoading) {
<span>Save and Proceed</span>
}
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-spin"></i> Saving...</span>
}
  </button>
  <button class="btn btn-danger-outline btn-sm" 
          type="button" 
          (click)="reset()" 
          [disabled]="crudLoading">
    Reset
  </button>
  <button class="btn btn-warning btn-sm" 
          type="button" 
          (click)="cancel()" 
          [disabled]="crudLoading">
    Cancel
  </button>
</div>

